import api from '../services/api';
import { $Q } from '../utils/querySelector';
import { RenderElements } from '../utils/renderElement';
import { dataToggle } from '../utils/toggleDataset';
import { Cart } from './cart';

export class ActivationKey {
  constructor() {
    this.success = document.querySelector('.product__description--success');
    this.container = document.querySelector(
      '.product__container-activation-key'
    );
    this.properties = [
      'properties[activation_key_model]',
      'properties[activation_key_serial]',
      'properties[activation_key_image]',
    ];
    this.container && this.init();
  }

  init() {
    this.wrapper = this.container.querySelector(
      '.product__description--activation-key'
    );
    this.form = this.container.querySelector('.add-cart-activation-key__form');
    this.cta = this.form.querySelector('#main-add-cart');
    this.fileZone = this.container.querySelector('.activation-key__file');
    this.fileWrapper = this.fileZone.closest('.activation-key__field');
    this.fileInput = this.fileWrapper.closest('input[type="field"]');
    this.fileDetails = this.container.querySelector('.activation-key__image');
    this.renderElements = new RenderElements();

    this.wrapper.addEventListener('change', this.handleChange.bind(this));
    this.form.addEventListener('submit', this.handleForm.bind(this));
    this.fileZone.addEventListener('drop', this.onFileDrop.bind(this));
    this.fileZone.addEventListener('change', this.onFileChange.bind(this));

    this.properties.forEach(
      function (property) {
        this.container
          .querySelector(`[name="${property}"]`)
          .removeAttribute('required');
      }.bind(this)
    );
  }

  handleChange(e) {
    if (!e.target.value) return;
    e.target.closest('.activation-key__field').classList.remove('has-errors');
  }

  async handleForm(e) {
    e.preventDefault();
    this.cta.disabled = true;
    this.success.classList.add('hidden');
    let isInvalid = false;
    const body = new FormData(this.form);
    const data = {};
    const cart = new Cart();

    for (const entry of body.entries()) {
      data[entry[0]] = entry[1];
    }

    this.properties.forEach(
      function (property, n) {
        const wrapper = this.container
          .querySelector(`[name="${property}"]`)
          .closest('.activation-key__field');
        if (
          !data[property] ||
          (n === 2 && !data[property]?.size) ||
          (n === 1 && data[property]?.length !== 7)
        ) {
          wrapper.classList.add('has-errors');
          isInvalid = true;
        } else {
          wrapper.classList.remove('has-errors');
        }
      }.bind(this)
    );

    if (isInvalid) {
      this.cta.disabled = false;
      return;
    }

    const response = await fetch(this.form.action, {
      method: 'POST',
      body,
    });

    if (response.status === 200) {
      this.success.classList.remove('hidden');
      this.fileDetails.classList.add('hidden');
      this.properties.forEach(
        function (property) {
          this.container.querySelector(`[name="${property}"]`).value = '';
        }.bind(this)
      );
      const sectionToRender = await api.renderShopifySection('side-cart');
      cart._updateSidecart({ sections: sectionToRender });
      dataToggle($Q('#shopify-section-side-cart'), true);
    } else {
      alert('There has been an issue');
    }
    this.cta.disabled = false;
  }

  onFileDrop(e) {
    e.preventDefault();
    const file = e.dataTransfer?.files?.[0];
    const processed = this.processFile(file);
    if (!processed) this.fileInput.value = '';
  }

  onFileChange(e) {
    e.preventDefault();
    const file = e.target?.files?.[0];
    const processed = this.processFile(file);
    if (!processed) this.fileInput.value = '';
  }

  processFile(file) {
    if (!file) return;
    const size = Number((file.size / (1024 * 1024)).toFixed(2));
    if (size > 10) {
      this.fileWrapper.classList.add('has-errors');
      this.fileDetails.classList.add('hidden');
      return false;
    }

    this.fileDetails.querySelector(
      '.activation-key__image-size'
    ).textContent = `${size} MB`;
    this.fileDetails.querySelector(
      '.activation-key__image-content span'
    ).textContent = file.name;
    this.fileDetails.querySelector('.activation-key__image-content a').href =
      URL.createObjectURL(file);
    this.fileDetails.classList.remove('hidden');

    return true;
  }

  async readCartElements() {
    try {
      return await api.read(`${routes.cart_url}.js`);
    } catch (error) {
      console.error(`Error: ${error}`);
    }
  }
}
